export const PERMISSIONS = {
    SYNC_VIEW: {
        code: 'sync:view',
        scope: 'sync',
        description: 'Xem danh sách đồng bộ',
    },
    SYNC_EDIT: {
        code: 'sync:edit',
        scope: 'sync',
        description: 'Thực hiện đồng bộ',
    },
    LEARNER_VIEW: {
        code: 'learner:view',
        scope: 'learner',
        description: 'Xem danh sách học viên',
    },
    LEARNER_EDIT: {
        code: 'learner:edit',
        scope: 'learner',
        description: 'Sửa thông tin học viên',
    },
    LEARNER_EVENT_VIEW: {
        code: 'learner-event:view',
        scope: 'learner-event',
        description: 'Xem lịch sử học viên',
    },
    LEARNER_STUDY_PLAN_VIEW: {
        code: 'learner-study-plan:view',
        scope: 'learner-study-plan',
        description: 'Xem kế hoạch học tập',
    },
    LEARNER_STUDY_PLAN_EDIT: {
        code: 'learner-study-plan:edit',
        scope: 'learner-study-plan',
        description: 'Sửa kế hoạch học tập',
    },
    LEARNER_STUDY_PLAN_SELF_EDIT: {
        code: 'learner-study-plan:self-edit',
        scope: 'learner-study-plan',
        description: 'Sửa kế hoạch học tập của chính mình',
    },
    LEARNER_STUDY_SPACE_SESSION_VIEW: {
        code: 'learner-study-space-session:view',
        scope: 'learner-study-space-session',
        description: 'Xem phiên học tập',
    },
    LEARNER_STUDY_SPACE_SESSION_EDIT: {
        code: 'learner-study-space-session:edit',
        scope: 'learner-study-space-session',
        description: 'Sửa phiên học tập',
    },
    LEARNER_STUDY_SPACE_SESSION_SELF_EDIT: {
        code: 'learner-study-space-session:self-edit',
        scope: 'learner-study-space-session',
        description: 'Sửa phiên học tập của chính mình',
    },
    TEST_VIEW: {
        code: 'test:view',
        scope: 'test',
        description: 'Xem mã đề thi',
    },
    COURSE_VIEW: {
        code: 'course:view',
        scope: 'course',
        description: 'Xem danh sách khóa học',
    },
    COURSE_EDIT: {
        code: 'course:edit',
        scope: 'course',
        description: 'Sửa thông tin khóa học',
    },
    EMPLOYEE_VIEW: {
        code: 'employee:view',
        scope: 'employee',
        description: 'Sửa thông tin nhân viên',
    },
    EMPLOYEE_EDIT: {
        code: 'employee:edit',
        scope: 'employee',
        description: 'Sửa thông tin nhân viên',
    },
    ROLE_VIEW: {
        code: 'role:view',
        scope: 'role',
        description: 'Xem thông tin phân quyền',
    },
    ROLE_EDIT: {
        code: 'role:edit',
        scope: 'role',
        description: 'Sửa thông tin phân quyền',
    },
    DEPARTMENT_VIEW: {
        code: 'department:view',
        scope: 'department',
        description: 'Xem thông tin phòng ban',
    },
    DEPARTMENT_EDIT: {
        code: 'department:edit',
        scope: 'department',
        description: 'Sửa thông tin phòng ban',
    },
    CLUSTER_VIEW: {
        code: 'cluster:view',
        scope: 'cluster',
        description: 'Xem thông tin cụm',
    },
    CLUSTER_EDIT: {
        code: 'cluster:edit',
        scope: 'cluster',
        description: 'Sửa thông tin cụm',
    },
    POSITION_VIEW: {
        code: 'position:view',
        scope: 'position',
        description: 'Xem thông tin vị trí công việc',
    },
    POSITION_EDIT: {
        code: 'position:edit',
        scope: 'position',
        description: 'Sửa thông tin vị trí công việc',
    },
    PROBATION_VIEW: {
        code: 'probation:view',
        scope: 'probation',
        description: 'Xem thông tin thử việc',
    },
    PROBATION_EDIT: {
        code: 'probation:edit',
        scope: 'probation',
        description: 'Sửa thông tin thử việc',
    },
    CENTER_VIEW: {
        code: 'center:view',
        scope: 'center',
        description: 'Xem danh sách trung tâm',
    },
    CENTER_EDIT: {
        code: 'center:edit',
        scope: 'center',
        description: 'Sửa thông tin trung tâm',
    },
    ROOM_VIEW: {
        code: 'room:view',
        scope: 'room',
        description: 'Xem danh sách phòng',
    },
    ROOM_EDIT: {
        code: 'room:edit',
        scope: 'room',
        description: 'Sửa thông tin phòng',
    },
    ROOM_STATUS_VIEW: {
        code: 'room-status-history:view',
        scope: 'room',
        description: 'Xem danh sách lịch sử trạng thái phòng',
    },
    ROOM_STATUS_CREATE: {
        code: 'room-status-history:create',
        scope: 'room',
        description: 'Tạo thông tin lịch sử trạng thái phòng',
    },
    ROOM_STATUS_UPDATE: {
        code: 'room-status-history:update',
        scope: 'room',
        description: 'Sửa thông tin lịch sử trạng thái phòng',
    },
    FILTER_VIEW_SHARED_MANAGE: {
        code: 'filter-view-shared:manage',
        scope: 'filter-view',
        description: 'Quản lý bộ lọc chia sẻ',
    },
    SETTING_VIEW: {
        code: 'setting:view',
        scope: 'setting',
        description: 'Xem danh sách cài đặt',
    },
    SETTING_EDIT: {
        code: 'setting:edit',
        scope: 'setting',
        description: 'Sửa thông tin cài đặt',
    },
    TICKET_VIEW: {
        code: 'ticket:view',
        scope: 'ticket',
        description: 'Xem danh sách ticket',
    },
    TICKET_CREATE: {
        code: 'ticket:create',
        scope: 'ticket',
        description: 'Tạo ticket mới',
    },
    TICKET_EDIT: {
        code: 'ticket:edit',
        scope: 'ticket',
        description: 'Sửa thông tin ticket',
    },
    CHECKLIST_VIEW: {
        code: 'checklist:view',
        scope: 'checklist',
        description: 'Xem danh sách checklist',
    },
    CHECKLIST_EDIT: {
        code: 'checklist:edit',
        scope: 'checklist',
        description: 'Sửa thông tin checklist',
    },
    LEAD_VIEW: {
        code: 'lead:view',
        scope: 'lead',
        description: 'Xem danh sách lead',
    },
    LEAD_CREATE: {
        code: 'lead:create',
        scope: 'lead',
        description: 'Tạo lead',
    },
    LEAD_UPDATE: {
        code: 'lead:update',
        scope: 'lead',
        description: 'Sửa lead',
    },
    LEAD_DELETE: {
        code: 'lead:delete',
        scope: 'lead',
        description: 'Xóa lead',
    },
    LEAD_ASSIGN: {
        code: 'lead:assign',
        scope: 'lead',
        description: 'Chia lead',
    },
    LEAD_ASSIGN_NOTE: {
        code: 'lead:assign-note',
        scope: 'lead',
        description: 'Ghi chú chia lead',
    },
    LEAD_CAMPAIGN_VIEW: {
        code: 'lead-campaign:view',
        scope: 'lead-campaign',
        description: 'Xem danh sách campaign',
    },
};